import { data } from '../../svg/Lookup/data';
import { makeIcon } from '../makeIcon';

export const Lookup = makeIcon(data, 'lookup', 'Lookup');

export default Lookup;
